import React from 'react';
import {findIndex, get, set, forEach, every, size, map, isEqual} from 'lodash';
import produce from 'immer';

const useCheckboxHandle = (data) => {
  const [results, setResults] = React.useState(data);
  const [masterChecked, setMasterChecked] = React.useState(false);
  React.useEffect(() => {
    if (
      size(results) === 0 ||
      !isEqual(map(results, 'entityId'), map(data, 'entityId')) || // In case of out sync
      size(results) !== size(data)
    ) {
      setResults(data);
      setMasterChecked(false);
    }
  }, [data]);

  const handleCheckboxChange = (id) => {
    const index = findIndex(results, {entityId: id});
    const updatedData = produce(results, (draft) => {
      const rowToUpdate = get(draft, index);
      set(rowToUpdate, 'checked', !get(rowToUpdate, 'checked', false));
    });
    setResults(updatedData), setMasterChecked(every(updatedData, ['checked', true]));
  };

  const handleMasterCheckbox = (value) => {
    const items = produce(results, (draft) => {
      forEach(draft, (entry) => {
        entry.checked = value;
      });
    });
    setResults(items);
    setMasterChecked(value);
  };

  return [results, masterChecked, handleCheckboxChange, handleMasterCheckbox];
};

export default useCheckboxHandle;
